/** Dusk Foundation testnet explorer (standing rule: never mainnet). */
export const EXPLORER_BASE = "https://apps.testnet.dusk.network/explorer";

/**
 * @param {string | null | undefined} hash
 * @returns {string | null}
 */
export function explorerTxUrl(hash) {
  if (!hash) return null;
  const id = String(hash).replace(/^0x/i, "").toLowerCase();
  if (!id) return null;
  return `${EXPLORER_BASE}/transactions/transaction?id=${encodeURIComponent(id)}`;
}

/**
 * @param {string | null | undefined} hash
 * @param {number} [keep=10]
 */
export function shortTxHash(hash, keep = 10) {
  if (!hash) return "-";
  const id = String(hash).replace(/^0x/i, "");
  if (id.length <= keep + 1) return id;
  return `${id.slice(0, keep)}…`;
}
